function header () {
  const body = document.querySelector('body')
  const header = document.querySelector('.l-header')
  let height = header.offsetHeight
  updateFixedPosition()

  window.addEventListener('resize', () => {
    height = header.offsetHeight
    updateFixedPosition()
  })

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
    header.classList.toggle('is-scrolled', scrollTop > height / 2)
  })

  document.querySelector('.header-content__meta__burger').addEventListener('click', e => {
    body.classList.toggle('not-scrollable')
  })

  function updateFixedPosition () {
    setTimeout(() => {
      header.style.position = 'fixed'
      body.style.paddingTop = height + 'px'
    }, 0)
  }
}

export default function () {
  header()
}



// WEBPACK FOOTER //
// ./themes/default/js/modules/layout.js